





















import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  props: {
    reportDate: {
      type: String,
      required: true,
    },
    timeRange: {
      type: String,
      required: true,
    },
    currentSheet: {
      type: Number,
      required: true,
    },
    totalSheets: {
      type: Number,
      required: true,
    },
  },
});
